import React, { useEffect, useState, useContext } from 'react'
import { components, constants, useServices, useTranslation } from 'cng-web-lib'
import AciHighwayCargoApiUrls from 'src/apiUrls/AciHighwayCargoApiUrls'
import FdapnResponseApiUrls from 'src/apiUrls/FdapnResponseApiUrls'
import AciHighwayKeys from 'src/constants/locale/key/AciHighwayResponse'
import Namespace from 'src/constants/locale/Namespace'
import moment from 'moment-timezone'
import {
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@material-ui/core'
import clsx from 'clsx'
import { FdaPNTranslationContext } from './../contexts/FDAPNTranslationContext.js'

const {
  table: { useFetchCodeMaintenanceLookup }
} = components

const {
  filter: { EQUAL }
} = constants

const useStyles = makeStyles((theme) => ({
  table: {
    '& .MuiTableHead-root': {
      backgroundColor: theme.palette.background.sectionOddBg,
      '& .MuiTableCell-head': {
        borderBottom: 0,
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.2,
        textTransform: 'uppercase'
      }
    },
    '& .MuiTableBody-root': {
      '& .MuiTableRow-root': {
        '&:last-child': {
          '& .MuiTableCell-root': {
            borderBottom: 0
          }
        }
      }
    },
    '& .MuiTableCell-root': {
      padding: '8px 16px'
    }
  }
}))

function ResponseSnRefInfo(props) {
  const { showNotification, id, isViewOnly = false, manifestId, cargoPage, refInfosData } = props

  const [data, setData] = useState([])
  const [lookups, setLookups] = useState(null)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const { fetchRecord, fetchRecords } = useServices()
  const { translate } = useTranslation([Namespace.ACE_HIGHWAY_RESPONSE])
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const classes = useStyles()
  const { getTranslatedText } = useContext(FdaPNTranslationContext)

  const combineDateAndTime = (date, time) => {
    const dateTime = moment(date).set({
      hour: parseInt(time.substring(0, 2), 10),
      minute: parseInt(time.substring(2, 4), 10),
    });
    return dateTime.tz("Canada/Eastern").format('D MMM YYYY HH:mm');
  };

  const columns = [
    {
      field: 'processingDate',
      title: getTranslatedText('FDAPN', 'processingDate'),
      render: (data) =>
        data.processingDate &&
        moment(data.processingDate).tz("Canada/Eastern").format('D MMM YYYY HH:mm')
    },
    {
      field: 'refIdQualifier',
      title: getTranslatedText('FDAPN', 'refIdQualifier'),
      render: (data) => data.refIdQualifier
    },
    {
      field: 'refIdNumber',
      title: getTranslatedText('FDAPN', 'refIdNumber'),
      render: (data) => data.refIdNumber
    },
    {
      field: 'refIdReceiptDate',
      title: getTranslatedText('FDAPN', 'refIdReceiptDate'),
      render: (data) => data.refIdReceiptDate && data.refIdreceiptTime && combineDateAndTime(data.refIdReceiptDate, data.refIdreceiptTime)
        // data.refIdReceiptDate &&
        // moment(data.refIdReceiptDate).tz("Canada/Eastern").format('D MMM YYYY HH:mm')
    },
    {
      field: 'pgaLineSubReasonCode',
      title: getTranslatedText('FDAPN', 'pgaLineSubReasonCode'),
      render: (data) => data.pgaLineSubReasonCode
    },
  ]

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value)
    setPage(0)
  }

  return (
    <>
      <TableContainer>
        <Table className={clsx(classes.table, 'new-ui-table-component__table')}>
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell key={index}>{column.title}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {refInfosData.length > 0 ? (
              refInfosData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((d) => (
                  <TableRow key={d.id}>
                    {columns.map((column, index) => (
                      <TableCell key={index}>
                        {column.render ? column.render(d) : d[column.field]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell align='center' colSpan={columns.length}>
                  <Typography variant='body2' color='textSecondary'>
                    No records to display
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
        component='div'
        count={refInfosData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}

export default ResponseSnRefInfo
